module.exports = __webpack_public_path__ + "webStatic/img/logo.b5b38dcd.png";